<template>
  <div>
    
      <el-container direction="vertical">
        <el-header>
          <THeader></THeader>
        </el-header>
        <el-main id="main">
          <router-view v-if="routerAlive" />
        </el-main>
        <el-footer>
          <BFooter></BFooter>
        </el-footer>
      </el-container>
      <div class="rightSuspension">
        <div class="phoneIcon" @mouseover="phoneIconStyle()"
            @mouseout="phoneIconOutStyle()">
          <img src="../static/image/phoneIcon.png"  class="phoneImg" alt="">
          <transition name="el-fade-in-linear">
            <div class="suspension" v-show="phoneShow">{{udata.mobile}}</div>
          </transition>
        </div>
        <div class="wxIcon" @mouseover="wxIconStyle()"
            @mouseout="wxIconOutStyle()">
          <img src="../static/image/wxIcon.png"  class="wxImg" alt="">
          <transition name="el-fade-in-linear">
            <div class="suspension" v-show="codeShow">
              <img :src="http+udata.wechat_qrcode" alt="" />
            </div>
          </transition>
        </div>
      </div>
  </div>
</template>

<script>
import { about } from "@/request/api";
import THeader from "@/components/Header/index";
import BFooter from "@/components/Footer/index";
export default {
  components: {
    THeader,
    BFooter,
  },
  watch: {
    $route(to, from) {
      if (to.path != "/list") {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    },
  },
  data() {
    return {
      routerAlive: true,
      phoneShow:false,
      http:this.$ImgHttp,
      udata:"",
      codeShow:false
    };
  },
  provide() {
    return {
      routerRefresh: this.routerRefresh,
    };
  },
  mounted(){    
    this.about()
  },
  methods: {
    about() {
      about()
        .then((res) => {
          // console.log(res);
          if(res.data.code == 1){
            this.udata = res.data.data
          }
        })
        .catch((err) => {});
    },
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    },
    phoneIconStyle() {
      this.phoneShow = true;
    },
    phoneIconOutStyle() {
      this.phoneShow = false;
    },
    wxIconStyle() {
      this.codeShow = true;
    },
    wxIconOutStyle() {
      this.codeShow = false;
    },
  },
};
</script>

<style lang='scss'>
.rightSuspension{
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translate(0%, -50%);
  z-index:100;
  .phoneIcon,.wxIcon{
    width: 60px;
    height: 60px;
    background: #FE4365;
    border-radius: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    .phoneImg{
      width: 25px;
      height: 36px;
    }
    .wxImg{
      width: 36px;
      height: 30px;
    }
    // .suspension2{
    //   width: 235px;
    //   background: #FFFFFF;
    //   box-shadow: 0px 0px 5px 0px rgba(170, 170, 170, 0.3);
    //   border-radius: 20px;
    // }
    .suspension {
      width: 235px;
      padding: 20px 0;
      background: #FFFFFF;
      box-shadow: 0px 0px 5px 0px rgba(170, 170, 170, 0.3);
      border-radius: 20px;
      position: absolute;
      top: 53%;
      left: -250px;
      transform: translate(0%, -58%);
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      font-size: 24px;
      color: #FE4365;
      img {
        width: 194px;
        height: 194px;
      }
    }
    .suspension::before {
      content: "";
      width: 10px;
      height: 10px;
      background-color: inherit;
      right: -5px; /*向左侧外部延伸箭头box的一半宽度*/
      position: absolute;
      transform: rotate(45deg); /*旋转45度*/
      top: 50%; /*箭头在数值方向上居中*/
      margin-top: -5px;
    }
  }
}
.el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #fe4365 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #5f5153 !important;
}

.el-breadcrumb__item {
  font-size: 20px;
  color: #333333 !important;
}
.el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-select-dropdown__item {
  height: 80px;
  line-height: 80px;
  font-size: 20px;
  font-weight: bold;
  color: #333333 !important;
}
.el-container {
  // height: 100%;
}
.el-header {
  width: 100%;
  position: fixed;
  top: 0;
  height: 100px !important;
  // background: rgba(0, 0, 0, 0.15);
  z-index: 10000;
}
.el-main {
  min-height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/ImportFile.vue